import { Modal } from 'antd'
import React from 'react'
import CodeEditorSheet, { codeModalProps } from '@src/components/Common/CodeEditorSheet';
import useMetadataEditor from './useMetadataEditor';

const TeamMetadataModal = ({ modalVisible, setModalVisible, handleModalSubmit, metadata }: { modalVisible: boolean, setModalVisible: Function, handleModalSubmit: (metadata: object | null) => void, metadata: any }) => {

    const { value, setValue, error, commit } = useMetadataEditor({
        metadata,
        onCommit: (parsed) => {
            handleModalSubmit(parsed);
            setModalVisible(false);
        },
    });

    return (
        <Modal
            {...codeModalProps('Team metadata')}
            open={modalVisible}
            onOk={commit}
            onCancel={() => setModalVisible(false)}
            okText="Save"
        >
            <CodeEditorSheet
                language="yaml"
                value={value}
                onChange={setValue}
                error={error}
                hint="Leave empty to clear the metadata"
                ariaLabel="Team metadata"
            />
        </Modal>
    )
}

export default TeamMetadataModal;
